
//transaction routes for Client
import ClientEn from '../client/translation/en/global.json';
import ClientAr from '../client/translation/ar/global.json';

import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                // admin: {
                //     translation: adminEn,
                // },
                // pharmacy: {
                //     translation: PharmacyAdminEn,
                // },
                // client: {
                // },
                translation: ClientEn,
            },
            ar: {
                // admin: {
                //     translation: adminAr,
                // },
                // pharmacy: {
                //     translation: PharmacyAdminAr,
                // },
                // client: {
                // },
                translation: ClientAr,
            }
        },
        lng: 'en',
        fallbackLng: "en",
        keySeparator: false,
        debug: true,
        interpolation: {
            escapeValue: false
        },
        // ns: ["admin", "pharmacy","client"],
        // defaultNS: "client",
    });

export default i18n;



